import { Component, ViewEncapsulation, ViewChild, ChangeDetectorRef } from '@angular/core';
import { SAUTableModule } from '@some-angular-utils/table';
import { Urls } from '@/apiConnection/urls';
import { ApiService } from '@/apiConnection/ApiService';
import { CentToEurDisplayDirective } from '@/directives/cent-to-eur-display.directive';

@Component({
  imports: [
    SAUTableModule,
    CentToEurDisplayDirective,
  ],
  templateUrl: './stock-report.page.html',
  styleUrl: './stock-report.page.scss',
  encapsulation: ViewEncapsulation.None
})
export class ProductStockReportCostPage {

  @ViewChild('sauTable')
  sauTable: { refresh: () => void; } | undefined;

  public url = Urls.urls.productsStockReport;

  printing = false;
  orientation: "dynamic" | "horizontal" | "vertical" = 'dynamic';
  showOptions = true;
  limitNumber = 10;

  public headers = [
    { name: 'Código', key: 'code' },
    { name: 'Nombre', key: 'name' },
    { name: 'Familia', key: 'category.name' },
    { name: 'Medida', key: 'measurement.short_name' },
    { name: 'Stock', key: 'stock' },
    { name: 'Precio coste', key: 'cost' },
    { name: 'Valor', key: 'value_cost' },
  ];

  public filterConfigBackup: any = null;
  public filterConfig: any = {
    orderParamName: 'sort',
    orderByFields: [
      { field: 'name', label: 'Nombre' },
      { field: 'stock', label: 'Stock' },
    ],
    order: ['search', 'category', 'provider'],
    mobile: ['search'],
    form: {
      search: {
        name: 'Buscar',
        key: 'search',
        type: 'inputText',
      },
      category: {
        name: 'Familia',
        key: 'category_id',
        type: 'selectMultiple',
        dropdowns: [],
      },
      provider: {
        name: 'Proveedor',
        key: 'provider_id',
        type: 'selectSimple',
        dropdowns: [],
      },
    }
  };

  public dropdowns: any = {
    categories: [],
    providers: [],
  };

  constructor(
    private cdr: ChangeDetectorRef,
    private apiService: ApiService,
  ) { }

  ngOnInit(): void {
    this.getDropdowns();
  }

  getDropdowns() {
    const config = { categories: {}, providers: {} };
    this.apiService.getSelectors(Urls.urls.selectors, config).subscribe({
      next: (data: any) => {
        this.dropdowns.categories = data.categories || [];
        this.dropdowns.providers = data.providers || [];

        this.filterConfig.form.category.dropdowns.push(...data.categories || []);
        this.filterConfig.form.provider.dropdowns.push(...data.providers || []);

        this.cdr.detectChanges();
      }
    });
  }

  printReport() {
    if (this.printing) return;
    this.printing = true;

    this.filterConfigBackup = this.filterConfig;

    this.orientation = 'horizontal';
    this.showOptions = false;
    this.filterConfig = null;
    this.limitNumber = 9999999;
    this.cdr.detectChanges();
    this.sauTable?.refresh();
  }

  finishLoad(event: any) {
    if (this.printing) {
      window.print(); // this will stop automatically

      this.orientation = 'dynamic';
      this.showOptions = true;
      this.filterConfig = this.filterConfigBackup;
      this.limitNumber = 10;
      this.printing = false;
      this.cdr.detectChanges();
      this.sauTable?.refresh();
    }
  }
}
